import { createContext } from 'react';
export const PopoutContext = createContext({
    forceUpdate: null,
});
//# sourceMappingURL=PopoutContext.js.map